import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./ActivityEvent.styled";
import { ActivityEventIcon } from "./ActivityEventIcon";
export const ActivityEvent = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { customIndicator, icon, indicatorPalette, indicatorType = "icon", notes, meta, titleHeadingLevel, title, children, ...otherProps } = props;
    return (_jsx(Styled.Activity, { ref: ref, "data-testid": "ActivityEvent", ...otherProps, children: _jsxs(Styled.ActivityContainer, { children: [_jsx(Styled.IconContainer, { children: customIndicator ? (customIndicator) : (_jsx(ActivityEventIcon, { icon: icon, palette: indicatorPalette, indicatorType: indicatorType })) }), title && _jsx(Styled.Title, { as: titleHeadingLevel, children: title }), meta && _jsx(Styled.Meta, { children: meta }), notes && _jsx(Styled.Notes, { children: notes }), children] }) }));
});
ActivityEvent.displayName = "ActivityEvent";
ActivityEvent.defaultProps = {
    indicatorType: "icon"
};
